import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";

// Admin: broadcasts sent from the bot (2026-10-20). A new one is made in the bot: /broadcast
const STATUS: Record<string, { text: string; color: string }> = {
  SENDING: { text: "Идёт отправка", color: "#f59e0b" },
  SENT: { text: "Отправлена", color: "#10b981" },
  FAILED: { text: "Прервана", color: "#ef4444" },
};

function when(v: string | null) {
  if (!v) return "—";
  return new Date(v).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function AdminBroadcasts() {
  const navigate = useNavigate();
  const [items, setItems] = useState<any[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/admin/bc").then((r: any) => setItems(r.data.items)).catch(() => setError(true));
  }, []);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Админ-панель</h1>
      <div style={styles.tabs}>
        <button style={styles.tabBtn} onClick={() => navigate("/admin")}>Статистика</button>
        <button style={{ ...styles.tabBtn, ...styles.tabBtnActive }}>Рассылки</button>
      </div>
      <div style={styles.hint}>Новая рассылка создаётся в чате с ботом командой /broadcast.</div>

      {error && <div style={{ ...styles.hint, marginTop: "12px" }}>Не удалось загрузить рассылки</div>}
      {!items && !error && <div style={styles.center}><div style={styles.spinner} /></div>}
      {items && items.length === 0 && <div style={{ ...styles.hint, marginTop: "12px" }}>Рассылок пока не было</div>}

      <div style={{ ...styles.list, marginTop: "12px" }}>
        {(items || []).map((b: any) => {
          const st = STATUS[b.status] || { text: b.status, color: "#9ca3af" };
          return (
            <div key={b.id} style={styles.card} onClick={() => navigate(`/admin/broadcasts/${b.id}`)}>
              <div style={styles.cardTop}>
                <span style={styles.cardTitle}>#{b.id} · {b.audience}</span>
                <span style={{ ...styles.badge, backgroundColor: st.color }}>{st.text}</span>
              </div>
              <div style={styles.hint}>{when(b.sent_at || b.created_at)}</div>
              {b.preview && <div style={styles.preview}>{b.preview}</div>}
              <div style={styles.numbers}>
                <span>Получателей {b.total}</span>
                <span>Доставлено {b.ok}</span>
                {b.button !== "none" && <span>Нажали {b.clicked}</span>}
                {b.blocked > 0 && <span>Заблок. {b.blocked}</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { padding: "16px", maxWidth: "480px", margin: "0 auto" },
  title: { fontSize: "22px", fontWeight: 700, margin: "0 0 16px 0", color: "var(--tg-theme-text-color, #000)" },
  tabs: { display: "flex", gap: "8px", marginBottom: "12px" },
  tabBtn: { flex: 1, padding: "8px", borderRadius: "10px", border: "none", backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", color: "var(--tg-theme-text-color, #000)", fontSize: "13px", cursor: "pointer" },
  tabBtnActive: { backgroundColor: "var(--tg-theme-button-color, #2481cc)", color: "var(--tg-theme-button-text-color, #fff)" },
  center: { display: "flex", justifyContent: "center", padding: "40px 0" },
  spinner: { width: "28px", height: "28px", border: "3px solid #e5e7eb", borderTop: "3px solid #3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite" },
  hint: { fontSize: "12px", color: "var(--tg-theme-hint-color, #666)" },
  list: { display: "flex", flexDirection: "column", gap: "8px" },
  card: { backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", borderRadius: "12px", padding: "12px", cursor: "pointer", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" },
  cardTop: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px", marginBottom: "2px" },
  cardTitle: { fontSize: "14px", fontWeight: 600, color: "var(--tg-theme-text-color, #000)" },
  badge: { fontSize: "11px", color: "#fff", padding: "2px 8px", borderRadius: "10px", whiteSpace: "nowrap" },
  preview: { fontSize: "13px", color: "var(--tg-theme-text-color, #000)", marginTop: "6px", whiteSpace: "pre-wrap", overflow: "hidden", maxHeight: "36px" },
  numbers: { display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "8px", fontSize: "12px", color: "var(--tg-theme-hint-color, #666)" },
};
